import { render, staticRenderFns } from "./YButton.vue?vue&type=template&id=c208474a&scoped=true"
import script from "./YButton.vue?vue&type=script&lang=js"
export * from "./YButton.vue?vue&type=script&lang=js"
import style0 from "./YButton.vue?vue&type=style&index=0&id=c208474a&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c208474a",
  null
  
)

export default component.exports